import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { MotivoRetrasoEmbarqueService } from '../../../services/MotivoRetrasoEmbarqueService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'motivo_clave',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. RE-01',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'motivo_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Descripción del retraso',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const MotivoRetrasoEmbarqueForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await MotivoRetrasoEmbarqueService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await MotivoRetrasoEmbarqueService.guardar(values);
  };

  return (
    <CatalogForm
      title="Motivo de Retraso de Embarque"
      subtitle="Causales de demora o atraso en procesos de embarque"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/MotivosAtrasoEmbarque"
    />
  );
};

export default MotivoRetrasoEmbarqueForm;
